import { css } from "@emotion/react"
import tw from "twin.macro"

export const tabAnimation = css`
  &:after {
    ${tw`absolute w-full rounded-full h-px bottom-0 left-0 bg-gray-900 origin-bottom-left transition-transform ease-out duration-300`}
    ${tw`h-px`}
      content: "";
    transform: scaleX(0);
  }
  @media (min-width: 1024px) {
    &:hover:after {
      transform: scaleX(1);
      ${tw`origin-bottom-left bg-gray-900 h-px`}
    }
  }
`

export const focusAnimation = css`
  &:focus-visible:after {
    ${tw`absolute w-full rounded-full h-px bottom-0 left-0 bg-gray-900 origin-bottom-left transition-transform ease-out duration-300`}
    ${tw`h-px`}
   content: "";
    transform: scaleX(0);
  }
  @media (min-width: 1024px) {
    &:focus-visible:after {
      transform: scaleX(1);
      ${tw`origin-bottom-left bg-gray-900 h-px`}
    }
  }
`

export const activeAnimation = css`
  ${tw`font-semibold focus-visible:(border-transparent)`}
  &:after {
    transform: scaleX(1);
    ${tw`h-1 bg-red-400`}
  }
  &:hover:after {
    ${tw`h-1 bg-red-400`}
  }
  &:focus-visible:after {
    transform: scaleX(1);
    ${tw`h-1 bg-red-400`}
  }
`

export const activeAnimationBorderDashed = css`
  ${tw`font-semibold focus-visible:(border-gray-900 border-dashed border outline-none)`}
  &:after {
    transform: scaleX(1);
    ${tw`h-1 bg-red-400`}
  }
  &:hover:after {
    ${tw`h-1 bg-red-400`}
  }
  &:focus-visible:after {
    transform: scaleX(1);
    ${tw`h-1 bg-red-400`}
  }
`

export const redUnderlineAnimation = css`
  &:after {
    ${tw`absolute w-full rounded-full h-px bottom-0 left-0 bg-red-400 origin-bottom-left transition-transform ease-out duration-300`}
    content: "";
    transform: scaleX(0);
  }
  @media (min-width: 1024px) {
    &:hover:after {
      transform: scaleX(1);
      ${tw`origin-bottom-left`}
    }
  }
  &:focus-visible:after {
    transform: scaleX(1);
    ${tw`origin-bottom-left`}
  }
`

export const blackUnderlineAnimation = css`
  &:after {
    ${tw`absolute w-full rounded-full h-[4px] -bottom-0.5 left-0 bg-black origin-bottom-left transition-transform ease-out duration-300`}
    content: "";
    transform: scaleX(0);
  }
  @media (min-width: 1024px) {
    &:hover:after {
      transform: scaleX(1);
      ${tw`origin-bottom-left`}
    }
  }
  &:focus:after {
    transform: scaleX(0);
  }
`

export const grayUnderlineAnimation = css`
  &:after {
    ${tw`absolute w-full rounded-full h-[1px] bottom-0 left-0 bg-gray-600 origin-bottom-left transition-transform ease-out duration-300`}
    content: "";
    transform: scaleX(0);
  }
  @media (min-width: 1024px) {
    &:hover:after {
      transform: scaleX(1);
      ${tw`origin-bottom-left`}
    }
  }
  &:focus:after {
    transform: scaleX(0);
  }
`

export const hoverAnimation = css`
  &:hover > .darkRed {
    ${tw`translate-x-11 duration-300`}
  }
  &:hover > .lighterRed {
    ${tw`opacity-100 delay-200`}
  }
  &:hover > .lightestRed {
    ${tw`opacity-100 delay-100`}
  }
`

export const subheadingHoverAnimation = css`
  @media (min-width: 1024px) {
    &:hover > .darkRed {
      ${tw`opacity-100 duration-300 translate-x-11`}
    }
    &:hover > .lighterRed {
      ${tw`opacity-100 delay-200 translate-x-8`}
    }
    &:hover > .lightestRed {
      ${tw`opacity-100 delay-100 translate-x-5`}
    }
  }
`

export const subheadingFocusAnimation = css`
  @media (min-width: 1024px) {
    &:focus-visible > .darkRed {
      ${tw`opacity-100 duration-300 translate-x-11`}
    }
    &:focus-visible > .lighterRed {
      ${tw`opacity-100 delay-200 translate-x-8`}
    }
    &:focus-visible > .lightestRed {
      ${tw`opacity-100 delay-100 translate-x-5`}
    }
  }
`
